export class WidgetNameCleanupValueConverter {
  toView(name?: string): string {
    return name?.replace(' (light)', '');
  }
}
